import React, {useState} from 'react';
import {
    Button,
    Layout,
    message,
    Popconfirm,
    Spin,
    Typography,
    Switch,
    Popover,
    Col,
    Row,
    Space,
    Divider,
    Image
} from "antd";
import {logout} from "../tools/firebase";
import {track} from "@amplitude/analytics-browser";
import {useTheme} from "./ThemeSwitching/use-theme";
import {SiDiscord} from "react-icons/si";
import {useNavigate} from "react-router-dom";

import {SettingOutlined} from "@ant-design/icons";
import logo from "./Resources/logo.png";

const { Header } = Layout;
const { Title, Text } = Typography;

const DashboardHeader = ({token, name, showTips, setShowTips}) => {

    const navigate = useNavigate();
    const [darkMode, setDarkMode] = useTheme();

    const textColor = darkMode ? "white" : "white";

    const copyToken = () => {
        track("token_copy_clicked");
        navigator.clipboard.writeText(token);
        message.success("Token copied");
    }

    const content = (
        <div className="flex flex-row">
            <div className="flex flex-row items-center">
                <div style={{color: textColor}}>
                    {
                        token === ""
                            ? <Spin/>
                            : `API Token: ${token.substring(0, 8)}...`
                    }
                </div>
                <Button
                    onClick={copyToken}
                    type="link"
                    disabled={token === ""}
                >
                    Copy
                </Button>
            </div>

            <div className="flex flex-row items-center">
                <Text style={{marginRight: 16, color: textColor}}>
                    Dark mode
                </Text>
                <Switch
                    checked={darkMode}
                    onChange={setDarkMode}
                />
            </div>

            <div className="flex flex-row items-center">
                <Text style={{marginRight: 16, color: textColor}}>
                    Show tips
                </Text>
                <Switch
                    checked={showTips}
                    onChange={setShowTips}
                />
            </div>

            <div className="flex flex-row items-center">

                <Button
                    type="primary"
                    shape="circle"
                    icon={<SiDiscord color="white" style={{marginTop: 5}}/>}
                    size='large'
                    onClick={() => {window.open("https://discord.gg/88tMErrSuq")}}
                    style={{marginRight: 64}}
                />

                {/*<Button*/}
                {/*    type="link"*/}
                {/*    onClick={() => {window.open("https://discord.gg/88tMErrSuq")}}*/}
                {/*>*/}
                {/*    Join our Discord*/}
                {/*</Button>*/}

            </div>
        </div>
    );

    return (
        <Header className="header" style={{fontFamily: "Avenir"}}>
            <div className="flex flex-row justify-between">
                <div className="flex flex-row items-center gap-4">
                    <Image src={logo} preview={false} style={{width: "2rem", height: "2rem"}}/>
                    <Title
                        level={3}
                        style={{color: "white", marginBottom: 0}}
                        onClick={() => { navigate("/") }}
                    >
                        Dimensions
                    </Title>
                </div>
                {/*<div className="basis-1/2">*/}
                {/*        {content}*/}
                {/*</div>*/}
                <div className="flex flex-row gap-16">
                    <div className="flex flex-row gap-2">
                        <div style={{color: textColor}}>
                            {
                                token === ""
                                    ? <Spin/>
                                    : `Token: ${token.substring(0, 8)}...`
                            }
                        </div>
                        <Button
                            onClick={copyToken}
                            type="link"
                            style={{marginTop: 16}}
                            disabled={token === ""}
                        >
                            Copy token
                        </Button>
                    </div>
                    <div className="flex flex-row gap-2">
                        <div style={{color: "white"}}>
                            {
                                name === ""
                                    ? <Spin/>
                                    : name
                            }
                        </div>
                        <Popconfirm
                            title="Are you sure？"
                            okText="Yes"
                            cancelText="No"
                            onConfirm={() => {
                                track("logout_clicked");
                                logout();
                            }}
                            onCancel={ () => {}}
                        >
                            <Button
                                style={{marginTop: 16}}
                                type="link"
                                disabled={token === ""}
                            >
                                Logout
                            </Button>
                        </Popconfirm>
                    </div>
                </div>
            </div>
        </Header>
    );
};

export default DashboardHeader;